import React, { ReactNode } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { Alert, Box, Grid } from "@mui/material";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { ModifyUserInfo } from "source/components/framework/User/ModifyUserInfo";
import { ListDetailsPanelAccordion } from "source/components/framework/List/ListDetailsPanel/ListDetailsPanelAccordion";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";

interface IDocumentListDetailsPanelDocumentContentProps {
    companyId: string;
    comment: string;
    content: string;
    directoryItemId: string;
    errorMessage: string;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    subTitle?: string;
    buttons?: ReactNode;
}

export const DocumentListDetailsPanelDocumentContent = (props: IDocumentListDetailsPanelDocumentContentProps) => {
    if (props.errorMessage) {
        return (
            <Alert severity="error">{props.errorMessage}</Alert>
        );
    }

    const userColumnWidth = props.createUser && props.modifyUser?.date ? 6 : 12;

    return (
        <>
            <div style={{ padding: "8px 16px 16px" }}>
                <GridRow>
                    {!!props.createUser &&
                        <Grid item sm={userColumnWidth}>
                            <FormField title={Translations.DocumentCreated} fullWidth margin={0}>
                                <ModifyUserInfo
                                    modifyUser={props.createUser}
                                />
                            </FormField>
                        </Grid>
                    }
                    {!!props.modifyUser?.date &&
                        <Grid item sm={userColumnWidth}>
                            <FormField title={Translations.DocumentModified} fullWidth margin={0}>
                                <ModifyUserInfo
                                    modifyUser={props.modifyUser}
                                />
                            </FormField>
                        </Grid>
                    }
                </GridRow>
            </div>
            <ListDetailsPanelAccordion
                title={Translations.Contents}
                subTitle={props.subTitle}
                buttons={props.buttons}
            >
                <div style={{ margin: 0, padding: 0, maxWidth: "100%", height: "100%", overflowX: "auto" }}>
                    {!!props.comment &&
                        <Box sx={{ display: "flex", fontStyle: "italic", whiteSpace: "pre-wrap", marginBottom: "1em" }}>
                            <Box>{`${Translations.Description}: `}</Box>
                            <Box>{props.comment}</Box>
                        </Box>
                    }
                    <div style={{ fontFamily: "Arial", fontSize: "14px", overflowWrap: "anywhere" }} dangerouslySetInnerHTML={ { __html: props.content } } />
                </div>
            </ListDetailsPanelAccordion>
        </>
    );
};